import { render } from "./SubtitleSectionBlock.vue?vue&type=template&id=3ab525ba&scoped=true"
import script from "./SubtitleSectionBlock.vue?vue&type=script&lang=js"
export * from "./SubtitleSectionBlock.vue?vue&type=script&lang=js"

import "./SubtitleSectionBlock.vue?vue&type=style&index=0&id=3ab525ba&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab525ba"]])

export default __exports__